import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';
import {
  BackButton,
  LeadingArea,
  LogoImage,
  LogoSlot,
  Subtitle,
  Title,
  TitleArea,
  TitleStack,
} from './TitleBar.styles';

export function TitleBarLeading({
  title,
  subtitle,
  hasBackButton,
  logoSrc,
  wideLogo = false,
}: {
  title?: string;
  subtitle?: string;
  hasBackButton: boolean;
  logoSrc: string;
  wideLogo?: boolean;
}) {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  return (
    <LeadingArea>
      {hasBackButton ? (
        <BackButton
          data-ph-no-autocapture
          onClick={() => {
            trackEvent(ANALYTICS_EVENTS.TITLEBAR_BACK_BUTTON_CLICKED);
            void navigate(-1);
          }}
          aria-label="Go back"
        >
          <ChevronLeft size={24} />
        </BackButton>
      ) : (
        <LogoSlot $wide={wideLogo} data-ph-no-autocapture>
          <LogoImage src={logoSrc} alt="Logo" onClick={() => void navigate('/')} />
        </LogoSlot>
      )}
      <TitleArea>
        <TitleStack>
          {title && <Title data-ph-no-autocapture>{title}</Title>}
          {subtitle && <Subtitle data-ph-no-autocapture>{subtitle}</Subtitle>}
        </TitleStack>
      </TitleArea>
    </LeadingArea>
  );
}
